import { cva, type VariantProps } from 'class-variance-authority';
import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { cn } from '@/shared/lib/utils';
import { Text } from '../text';

const statusVariants = cva('inline-flex items-center justify-center rounded-full text-sm', {
  variants: {
    variant: {
      neutral: 'bg-surface-strength2 text-text-secondary',
      success: 'bg-green-100 text-green-800',
      error: 'bg-red-100 text-red-800',
      warning: 'bg-yellow-100 text-yellow-800',
      info: 'bg-blue-100 text-blue-800',
      inverse: 'bg-stone-500 text-text-inverse',
    },
  },
  defaultVariants: {
    variant: 'neutral',
  },
});

export type StatusVariant = VariantProps<typeof statusVariants>['variant'];
type StatusProps = ComponentPropsWithoutRef<'span'> & {
  /**
   * ステータスのラベルテキスト
   */
  children: ReactNode;
  /**
   * ステータスのバリアント
   */
  variant: StatusVariant;
};

/**
 * Status コンポーネント
 *
 * ステータス表示用のバッジコンポーネント。複数のカラーバリエーションとサイズをサポート。
 */
export const Status = ({ children, variant = 'neutral', className, ...props }: StatusProps) => {
  return (
    <div
      className={cn(statusVariants({ variant }), 'h-[26px] min-w-[4rem] px-[8px]', className)}
      {...props}
    >
      {typeof children === 'string' ? (
        <Text as="span" variant={'description'} className="font-medium text-inherit">
          {children}
        </Text>
      ) : (
        children
      )}
    </div>
  );
};
